import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { NgxTypedJsModule } from "ngx-typed-js";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { FooterComponent } from "./components/layouts/footer/footer.component";
import { AppDownloadComponent } from "./components/common/app-download/app-download.component";
import { FeedbackComponent } from "./components/common/feedback/feedback.component";
import { VideoComponent } from "./components/common/video/video.component";
import { ProcessComponent } from "./components/common/process/process.component";
import { HeaderOneComponent } from "./components/layouts/header-one/header-one.component";
import { PartnerComponent } from "./components/common/partner/partner.component";
import { HeaderTwoComponent } from "./components/layouts/header-two/header-two.component";
import { HomeFourComponent } from "./components/pages/home-four/home-four.component";
import { InstagramComponent } from "./components/common/instagram/instagram.component";
import { HeaderThreeComponent } from "./components/layouts/header-three/header-three.component";
import { AboutComponent } from "./components/pages/about/about.component";
import { FunfactsComponent } from "./components/common/funfacts/funfacts.component";
import { HowItWorksComponent } from "./components/pages/how-it-works/how-it-works.component";
import { ContactComponent } from "./components/pages/contact/contact.component";
import { FaqComponent } from "./components/pages/faq/faq.component";
import { ErrorComponent } from "./components/pages/error/error.component";
import { LoginComponent } from "./components/pages/login/login.component";
import { RegisterComponent } from "./components/pages/register/register.component";
import { PatientAccountComponent } from "./components/pages/patient-account/patient-account.component";
import { EditProfileComponent } from "./components/pages/edit-profile/edit-profile.component";
import { RequestBookingComponent } from "./components/pages/request-booking/request-booking.component";
import { SwitchLanguageService } from "./components/common/services/switch-language.service";
import { LayoutService } from "./components/common/services/layout.service";
import { ApiService } from "./components/common/services/api.service";
import { DialogMessageComponent } from "./components/common/dialog-message/dialog-message.component";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import {
    HttpClientModule,
    HttpClient,
    HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MaterialModule } from "./material.module";
import { FormsModule } from "@angular/forms";
import { FormService } from "./components/common/services/form.service";
import { ModalService } from "./components/common/services/modal.service";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { DatePipe } from "@angular/common";
import { AuthService } from "./components/common/services/auth.service";
import { PatientReplyComponent } from "./components/common/patient-reply/patient-reply.component";
import {DiseaseComponent} from './components/pages/disease/disease.component'
import { HospitalsListComponent } from "./components/pages/hospitals-list/hospitals-list.component";
import { HospitalViewComponent } from "./components/pages/hospital-view/hospital-view.component";
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
    declarations: [
        AppComponent,
        FooterComponent,
        AppDownloadComponent,
        FeedbackComponent,
        VideoComponent,
        ProcessComponent,
        HeaderOneComponent,
        PartnerComponent,
        HeaderTwoComponent,
        HomeFourComponent,
        InstagramComponent,
        HeaderThreeComponent,
        AboutComponent,
        FunfactsComponent,
        HowItWorksComponent,
        ContactComponent,
        FaqComponent,
        ErrorComponent,
        LoginComponent,
        RegisterComponent,
        RequestBookingComponent,
        DialogMessageComponent,
        PatientAccountComponent,
        EditProfileComponent,
        PatientReplyComponent,
        DiseaseComponent,
        HospitalsListComponent,
        HospitalViewComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        NgxTypedJsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            //defaultLanguage: 'ar',
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        BrowserAnimationsModule,
        MaterialModule,
        FormsModule,
        BrowserAnimationsModule,
    ],
    providers: [
        SwitchLanguageService,
        LayoutService,
        ApiService,
        FormService,
        ModalService,
        { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
        DatePipe,
        AuthService,
    ],
    bootstrap: [AppComponent],
    entryComponents: [DialogMessageComponent, PatientReplyComponent],
})
export class AppModule {}
